var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedinIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.83438 6.67334H0.706543V19.9998H4.83438V6.67334Z",
    fill: "#3AA3B4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.74968 4.92407C4.10118 4.92407 5.19076 3.82401 5.19076 2.46203C5.19076 1.10006 4.10118 0 2.74968 0C1.39818 0 0.308594 1.10006 0.308594 2.46203C0.308594 3.82401 1.39818 4.92407 2.74968 4.92407Z",
    fill: "#3AA3B4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4348 13.0014C11.4348 11.1261 12.2939 10.0155 13.9492 10.0155C15.4684 10.0155 16.1913 11.0842 16.1913 13.0014C16.1913 14.9187 16.1913 19.9999 16.1913 19.9999H20.2981C20.2981 19.9999 20.2981 15.1282 20.2981 11.5556C20.2981 7.98306 18.2761 6.25439 15.4474 6.25439C12.6187 6.25439 11.4348 8.45451 11.4348 8.45451V6.66299H7.47461V19.9894H11.4348C11.4348 19.9999 11.4348 15.0549 11.4348 13.0014Z",
    fill: "#3AA3B4"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinIcon);
export default __webpack_public_path__ + "static/media/linkedin-icon.19724ce1882a3634f9af3c7d88f2f567.svg";
export { ForwardRef as ReactComponent };